// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StoresShowcase {
    width: 100%;
    box-sizing: border-box;
}

.StoresShowcase_Header {
    width: 100%;
    padding: 18px 0;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr auto;
}

.StoresShowcase_title {
    font-size: var(--titleShowcaseStoresTitleSize);
    line-height: var(--titleShowcaseStoresTitleLineHeight);
    font-weight: bold;
    font-family: inherit;
    color: var(--titleShowcaseStoresTitleColor);
    font-family: var(--font-family);
}

.StoresShowcase_link {
    display: flex;
    justify-content: end;
}

.StoresShowcase_link_span {
    font-weight: 500;
    color: var(--color-detached);
    font-size: var(--titleShowcaseStoresLinkSize);
    font-family: var(--font-family);
}

@media screen and (max-width: 768px) {
    .StoresShowcase_link_span {
        color: var(--color-detached);
        font-size: var(--font-small);
        font-family: var(--font-family);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/StoresShowcase/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,8CAA8C;IAC9C,sDAAsD;IACtD,iBAAiB;IACjB,oBAAoB;IACpB,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,6CAA6C;IAC7C,+BAA+B;AACnC;;AAEA;IACI;QACI,4BAA4B;QAC5B,4BAA4B;QAC5B,+BAA+B;IACnC;AACJ","sourcesContent":[".StoresShowcase {\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.StoresShowcase_Header {\n    width: 100%;\n    padding: 18px 0;\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    grid-template-columns: 1fr auto;\n}\n\n.StoresShowcase_title {\n    font-size: var(--titleShowcaseStoresTitleSize);\n    line-height: var(--titleShowcaseStoresTitleLineHeight);\n    font-weight: bold;\n    font-family: inherit;\n    color: var(--titleShowcaseStoresTitleColor);\n    font-family: var(--font-family);\n}\n\n.StoresShowcase_link {\n    display: flex;\n    justify-content: end;\n}\n\n.StoresShowcase_link_span {\n    font-weight: 500;\n    color: var(--color-detached);\n    font-size: var(--titleShowcaseStoresLinkSize);\n    font-family: var(--font-family);\n}\n\n@media screen and (max-width: 768px) {\n    .StoresShowcase_link_span {\n        color: var(--color-detached);\n        font-size: var(--font-small);\n        font-family: var(--font-family);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
